<!-- 热门模拟交易榜单 -->
<template>
  <div class="Mnjybd" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="title_t">
      <p>热门模拟交易榜单</p>
      <p @click="seeMore">更多<van-icon name="arrow" /></p>
    </div>
    <ul class="list">
      <li
        v-for="(item, index) in bdList"
        :key="item.id"
        :style="`background: url('${item.bgurl}')no-repeat top right; background-size: 100% 25%;`"
        class="list_li"
      >
        <p class="title">{{ item.title }}</p>

        <p class="desc" v-if="item.desc">{{ item.desc }}</p>

        <div class="tabs" v-if="item.tabs">
          <p
            v-for="(item2, index2) in item.tabs"
            :key="index2"
            @click="p_active = index2"
            :class="index2 === p_active ? 'p_active' : ''"
          >
            {{ item2 }}
          </p>
        </div>

        <ul class="bdList">
          <template v-for="(item3, index3) in todayRisk">
            <li
              class="bdList_li"
              v-if="index3 < 5 && index === 0 && p_active == 0"
              :key="item3.capitalId"
              @click="goMnDetail(item3)"
            >
              <div class="left">
                <p class="top">
                  <span class="index" v-if="index3 === 0" style="background: #f46363">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 1" style="background: #f90">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 2" style="background: #ffd953">{{
                    index3 + 1
                  }}</span>

                  <span class="index" v-else>{{ index3 + 1 }}</span>
                  <span class="name van-ellipsis one-txt-cut">{{ item3.name }}</span>
                  <span class="pay_icon" v-if="item3.reviewStatus == '1'" > <img :src="payImg" alt="" srcset=""> </span>
                </p>

                <p class="msg">
                  创建后收益
                  <span :class="[judgeColor(item3.totalRisk)]">
                    {{ toFixedNum(item3.totalRisk * 100, 2, '%') }}
                  </span>
                </p>
              </div>

              <div class="right">
                <p class="zf" :class="[judgeColor(item3.todayRisk)]">
                  {{ toFixedNum(item3.todayRisk * 100, 2, '%') }}
                </p>
                <p class="name">今日收益</p>
              </div>
            </li>
          </template>

          <template v-for="(item3, index3) in totalRisk">
            <li
              class="bdList_li"
              v-if="index3 < 5 && index === 0 && p_active == 1"
              :key="item3.capitalId"
              @click="goMnDetail(item3)"
            >
              <div class="left">
                <p class="top">
                  <span class="index" v-if="index3 === 0" style="background: #f46363">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 1" style="background: #f90">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 2" style="background: #ffd953">{{
                    index3 + 1
                  }}</span>

                  <span class="index" v-else>{{ index3 + 1 }}</span>
                  <span class="name one-txt-cut">{{ item3.name }}</span>
                  <span class="pay_icon" v-if="item3.reviewStatus == '1'" > <img :src="payImg" alt="" srcset=""> </span>
                </p>

                <p class="msg">
                  今日收益
                  <span :class="[judgeColor(item3.todayRisk)]">
                    {{ toFixedNum(item3.todayRisk * 100, 2, '%') }}
                  </span>
                </p>
              </div>

              <div class="right">
                <p class="zf" :class="[judgeColor(item3.totalRisk)]">
                  {{ toFixedNum(item3.totalRisk * 100, 2, '%') }}
                </p>
                <p class="name">创建后收益</p>
              </div>
            </li>
          </template>

          <template v-for="(item3, index3) in successRate">
            <li
              class="bdList_li"
              v-if="index3 < 5 && index === 2"
              :key="item3.capitalId"
              @click="goMnDetail(item3)"
            >
              <div class="left">
                <p class="top">
                  <span class="index" v-if="index3 === 0" style="background: #f46363">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 1" style="background: #f90">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 2" style="background: #ffd953">{{
                    index3 + 1
                  }}</span>

                  <span class="index" v-else>{{ index3 + 1 }}</span>
                  <span class="name one-txt-cut">{{ item3.name }}</span>
                  <span class="pay_icon" v-if="item3.reviewStatus == '1'" > <img :src="payImg" alt="" srcset=""> </span>
                </p>

                <p class="msg">
                  创建后收益
                  <span :class="[judgeColor(item3.totalRisk)]">
                    {{ toFixedNum(item3.totalRisk * 100, 2, '%') }}
                  </span>
                </p>
              </div>

              <div class="right">
                <p class="zf">
                  {{ toFixedNum(item3.successRate * 100, 2, '%') }}
                </p>
                <p class="name">交易胜率</p>
              </div>
            </li>
          </template>

          <template v-for="(item3, index3) in maxRetreatRate">
            <li
              class="bdList_li"
              v-if="index3 < 5 && index === 1"
              :key="item3.capitalId"
              @click="goMnDetail(item3)"
            >
              <div class="left">
                <p class="top">
                  <span class="index" v-if="index3 === 0" style="background: #f46363">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 1" style="background: #f90">{{
                    index3 + 1
                  }}</span>
                  <span class="index" v-else-if="index3 === 2" style="background: #ffd953">{{
                    index3 + 1
                  }}</span>

                  <span class="index" v-else>{{ index3 + 1 }}</span>
                  <span class="name one-txt-cut">{{ item3.name }}</span>
                  <span class="pay_icon" v-if="item3.reviewStatus == '1'" > <img :src="payImg" alt="" srcset=""> </span>
                </p>

                <p class="msg">
                  创建后收益
                  <span :class="[judgeColor(item3.totalRisk)]">
                    {{ toFixedNum(item3.totalRisk * 100, 2, '%') }}
                  </span>
                </p>
              </div>

              <div class="right">
                <p class="zf">
                  {{ toFixedNum(item3.maxRetreatRate * 100, 2, '%') }}
                </p>
                <p class="name">最大回撤</p>
              </div>
            </li>
          </template>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { getHotMokpanelList } from '@/api/index.js';
import { judgeColor, toFixedNum,compareVersions } from '@/utils/format';
import mixin from '@/mixins/index.js';
export default {
  name: 'Mnjybd',
  mixins: [mixin],
  props: [],

  data() {
    return {
      payImg: require('../../assets/image/pay-icon.png'),
      bdList: [
        {
          id: 0,
          title: '收益榜',
          bgurl: require('../../assets/image/syb2x.png'),
          tabs: ['今日收益', '创建后收益']
        },
        {
          id: 1,
          title: '稳健榜',
          bgurl: require('../../assets/image/wjb2x.png'),
          desc: '按模拟交易最大回撤从小到大排序'
        },
        {
          id: 2,
          title: '胜率榜',
          bgurl: require('../../assets/image/slb2x.png'),
          desc: '按模拟交易历史交易胜率从大到小排序'
        }
      ],
      p_active: 0,
      todayRisk: [], //今日收益
      totalRisk: [], //创建后收益
      successRate: [], //胜率榜
      maxRetreatRate: [], //稳健榜
      interval: null,
      isVip: false,
    };
  },
  filters: {},
  created() {},
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  async mounted() {
    this.getHotMokpanelListFun();

    this.interval = setInterval(() => {
      this.getHotMokpanelListFun();
    }, 1000 * 60);



  },
  methods: {
    judgeColor,
    toFixedNum,
    compareVersions,

    getHotMokpanelListFun: function () {
      var params = {};
      return getHotMokpanelList(params)
        .then((res) => {
          this.todayRisk = res.data.todayRisk;
          this.totalRisk = res.data.totalRisk;
          this.successRate = res.data.successRate;
          this.maxRetreatRate = res.data.maxRetreatRate;
        })
        .catch((err) => {
          this.$toast(err);
        });
    },
    // 跳转模拟详情
    goMnDetail: function (item) {
      // 判断是否是 vip
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71) ) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0704'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        location.href = '/mnDetail?DZHSPECIAL=4325641&type=hot&zj_id=' + item.capitalId;
      }
    },
    seeMore: function () {
      this.$router.push({
        path: '/mnjybdMore',
        query: this.$route.query
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>
<style lang="less" scoped>
.Mnjybd {
  padding: 0 0 0 16px;
  margin-top: 30px;

  .title_t {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 9px;
    padding-right: 16px;
    p {
      color: #222;
      &:first-child {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
      }
      &:last-child {
        border-radius: 10px;
        background: #f7f8fa;
        padding: 3px 6px 3px 10px;
        font-size: 10px;
        font-weight: 500;
      }
    }
  }
  .list {
    display: flex;
    width: 100%;
    overflow-x: auto;
    .list_li {
      width: 240px;
      border-radius: 8px;
      border: 1px solid #e5e5e5;
      height: 318px;
      flex-shrink: 0;
      margin-right: 10px;
      padding: 12px;
      margin-bottom: 2px;
      &:last-child {
        margin-right: 16px;
      }
      .title {
        color: #555;
        font-size: 16px;
        font-weight: bold;
      }
      .desc {
        color: #ccc;
        font-size: 12px;
        margin-top: 10px;
      }
      .tabs {
        display: flex;
        align-items: center;
        margin-top: 5px;
        p {
          color: #999;
          text-align: center;
          font-size: 11px;
          border-radius: 4px;
          border: 1px solid #f5f6f9;
          padding: 2px 8px;
          margin-right: 4px;
        }
        .p_active {
          color: #286df7;
          background: #eaf0fe;
          border: 1px solid #eaf0fe;
        }
      }
      .bdList {
        margin-top: 10px;
        .bdList_li {
          padding-bottom: 11px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 49px;

          .left {
            .top {
              display: flex;
              align-items: center;
              .index {
                border-radius: 4px;
                background: #999;
                width: 13px;
                height: 13px;
                color: #fff;
                font-size: 10px;
                font-weight: 600;
                flex-shrink: 0;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .name {
                color: #555;
                font-size: 14px;
                font-weight: 600;
                margin-left: 4px;
                max-width: 88px;
              }
            }
            .msg {
              color: #999;
              font-size: 11px;
              margin-top: 3px;
            }
            .pay_icon{
              width: 32px;
              height: 17px;
              margin-left: 4px;
            }
          }
          .right {
            .zf {
              font-size: 14px;
              font-weight: 600;
            }
            .name {
              color: #999;
              font-size: 11px;
              margin-top: 3px;
            }
          }
        }
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .title_t {
    p {
      &:first-child {
        color: #e4e9fe;
      }
      &:last-child {
        background: #1d202d;
        color: #e4e9fe;
      }
    }
  }
  .list {
    .list_li {
      border: none;
      background-color: #272935 !important;
      .title {
        color: #aab9d1;
      }
      .tabs {
        p {
          color: #e4e9fe;
          border: 1px solid #52545d;
        }
        .p_active {
          background: rgba(59, 133, 254, 0.2);
          border: 1px solid #2a3b5e;
        }
      }
      .bdList {
        .left {
          .top {
            .name {
              color: #aab9d1 !important;
            }
          }
        }
        .right {
          .zf {
            color: #999;
          }
        }
      }
    }
  }
}
</style>
